/**
Validation *
 * @file validation.js
 */

import $ from "jquery";
require('jquery-validation');


const validation = (() => {
    /**
     * Default Tab
     * Project default tab style
     */
    const writeToUsForm = () => {
        $('.write-to-us-form').validate({
            rules: {
                notificationType: {
                    required: true
                },
                message: {
                    required: true
                },
                name: {
                    required: true
                },
                email: {
                    required: true
                },
                phone: {
                    required: true
                },
                identityNumber: {
                    required: true
                },
                kvkk: {
                    required: true
                },
                // email: {
                //     required: true,
                //     email: true
                // }
            },
            messages: {
                notificationType: "Bu alanın doldurulması zorunludur.",
                message: "Bu alanın doldurulması zorunludur.",
                name: "Bu alanın doldurulması zorunludur.",
                email: "Bu alanın doldurulması zorunludur.",
                phone: "Bu alanın doldurulması zorunludur.",
                identityNumber: "Bu alanın doldurulması zorunludur.",
                kvkk: "Bu alanın doldurulması zorunludur.",
                // email: {
                //     required: "Lütfen bir e-posta adresi girin.",
                //     email: "Lütfen geçerli bir e-posta adresi girin."
                // }
            },
            // Hata mesajlarını yerleştireceğimiz alanı belirt
            // errorPlacement: function(error, element) {
            //     if (element.is(":radio") || element.is(":checkbox")) {
            //         error.appendTo(element.parent());
            //     } else {
            //         error.insertAfter(element);
            //     }
            // },
            // Hata olduğunda elemanın üst divine class ekleme
            highlight: function(element) {
                $(element).closest('.inp').addClass('error');
            },
            // Hata giderildiğinde elemanın üst divinden class kaldırma
            unhighlight: function(element) {
                $(element).closest('.inp').removeClass('error');
            }
        });
    };
  
    const init = () => {
        writeToUsForm();
    };
  
    return {
      init,
    };
  })();
  
  export default validation;
  